import { getBonusTitle } from 'js/utils/bonus.util';

export const parseBonus = ({ data, games, lang }) => {
    const parsedBonus = {
        ...data,
        bonusPopupTitle: getBonusTitle(data, { lang })
    };

    if (data?.bonusTemplate?.gamingContext?.selectedGames) {
        parsedBonus.bonusTemplate = {
            ...data.bonusTemplate,
            gamingContext: {
                ...data.bonusTemplate.gamingContext,
                selectedGames: data.bonusTemplate.gamingContext.selectedGames.filter(gameCode => games?.[gameCode]) || []
            }
        };
    }

    return parsedBonus;
};
